export const useDisabledAdv = () => {
  const cookie = useCook<boolean>('useDisabledAdv')
  return cookie
}

export const useExperimentsDiaryWide = () => {
  const cookie = useCook<boolean>('useExperimentsDiaryWide')
  return cookie
}



export const useTranslateLinks = () => {
  const cookie = useCook<boolean>('useTranslateLinks')
  return cookie
}


export const useExperimentsRegion = () => {
  const cookie = useCook<string>('useExperimentsRegion')
  return cookie
}

export const usePageBottomMargin = () => useState('usePageBottomMargin', () => 0)



export const useDiaryWeeksOrder = () => {

  const state = useState<string>('ui:weeks-order', () => {
    const cookieVal = useCook<string>('ui:weeks-order').value
    return cookieVal ?? 'desc'
  })
  const cookieRef = useCook<string>('ui:weeks-order')
  watch(state, (val) => {
    cookieRef.value = val
  })

  return state
}



